/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HistoryEntry } from './HistoryEntry';
import {
    HistoryEntryFromJSON,
    HistoryEntryFromJSONTyped,
    HistoryEntryToJSON,
} from './HistoryEntry';
import type { PagedResponse } from './PagedResponse';
import {
    PagedResponseFromJSON,
    PagedResponseFromJSONTyped,
    PagedResponseToJSON,
} from './PagedResponse';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface HistoryResponse
 */
export interface HistoryResponse extends PagedResponse {
    /**
     * 
     * @type {Array<HistoryEntry>}
     * @memberof HistoryResponse
     */
    historyEntries: Array<HistoryEntry>;
}

/**
 * Check if a given object implements the HistoryResponse interface.
 */
export function instanceOfHistoryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "historyEntries" in value;

    return isInstance;
}

export function HistoryResponseFromJSON(json: any): HistoryResponse {
    return HistoryResponseFromJSONTyped(json, false);
}

export function HistoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...PagedResponseFromJSONTyped(json, ignoreDiscriminator),
        'historyEntries': ((json['historyEntries'] as Array<any>).map(HistoryEntryFromJSON)),
    };
}

export function HistoryResponseToJSON(value?: HistoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...PagedResponseToJSON(value),
        'historyEntries': ((value.historyEntries as Array<any>).map(HistoryEntryToJSON)),
    };
}

